export default __webpack_public_path__ + "static/media/undefinedUser.63063464.jpeg";